import React, { useState, useEffect } from 'react'
import { BarChart, PieChart, Pie, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line }
    from 'recharts';
import { LuSubtitles } from "react-icons/lu";
import { MdCategory } from "react-icons/md";
import { SiDialogflow } from "react-icons/si";
import { TbBrandAirtable } from "react-icons/tb";
import { FaAmazonPay } from "react-icons/fa";
import { FaCcAmazonPay } from "react-icons/fa";
import { TbFileInvoice } from "react-icons/tb";
import { BiPurchaseTagAlt } from "react-icons/bi";
import { border, minWidth } from '@mui/system';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Loader from '../Common/Loader/loader';
// import { padding } from '@mui/system';


const Content = () => {

    const [val, setVal] = useState({});
    const [loading, setLoading] = useState(true);
    async function dashboardCount() {

        const res = await axios.get(`${process.env.REACT_APP_API_PATH}/ebench/admin/get_dashboard_stats`);
        const data = await res.data;
        if (data?.data) {
            setVal(data?.data);
            setLoading(false);
        }
    }
    console.log("dddrrr", loading)
    useEffect(() => {
        dashboardCount();
    }, [])

    const pieData = [
        { name: 'Vendor', value: 400 },
        { name: 'Job', value: 300 },
        { name: 'Selected Candidate', value: 300 },
        { name: 'Revenue', value: 200 },
    ];

    const data = [
        { name: 'Jan', revenue: 4000, pv: 2400, amt: 2400 },
        { name: 'Feb', revenue: 3000, pv: 1398, amt: 2210 },
        { name: 'Mar', revenue: 2000, pv: 9800, amt: 2290 },
        { name: 'Apr', revenue: 2780, pv: 3908, amt: 2000 },
        { name: 'May', revenue: 1890, pv: 4800, amt: 2181 },
        { name: 'Jun', revenue: 2390, pv: 3800, amt: 2500 },
        { name: 'Jul', revenue: 3490, pv: 4300, amt: 2100 },
        { name: 'Aug', revenue: 2580, pv: 3908, amt: 2000 },
        { name: 'sep', revenue: 2780, pv: 3908, amt: 2000 },
        { name: 'oct', revenue: 2780, pv: 3908, amt: 2000 },

    ];

    const data1 = [
        { name: 'Vendor', value: 400, verifiedVendor: 200, nonVerifyVendor: 145 },
        { name: 'Jobs', value: 300, postedJob: 130, onHoldJob: 100, expireJob: 34 },
        { name: 'Candidate', value: 300, selectedCandidates: 120, nonSelectedCandidate: 30 },
        { name: 'Interviews', value: 200, scheduleInterview: 123, CancelledInterview: 80, completedInterview: 135 },
        { name: "Purchase Order", value: 180, selectedCandidates: 230, createdOrder: 120, cancelledOrder: 220 }
    ];

    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

    const head = [
        {
            color: '#286a94',
            link: '/admin/vendor',
            title: 'Vendor',
            value: String((val?.activeVendors ?? 0) + (val?.inactiveVendors ?? 0)).padStart(2, '0'),
            icons: MdCategory,
            activeVendor: String(val?.activeVendors ?? 0).padStart(2, '0'),
            nonActiveVendor: String(val?.inactiveVendors ?? 0).padStart(2, '0')
        },
        {
            color: '#50AA54',
            link: '/admin/job',
            title: 'Jobs',
            value: String(
                (val?.deletedJobs ?? 0) +
                (val?.postedJobs ?? 0) +
                (val?.draftedJobs ?? 0) +
                (val?.expiredJobs ?? 0)
            ).padStart(2, '0'),
            icons: LuSubtitles,
            deletedJobs: String(val?.deletedJobs ?? 0).padStart(2, '0'),
            postedJob: String(val?.postedJobs ?? 0).padStart(2, '0'),
            draftedJobs: String(val?.draftedJobs ?? 0).padStart(2, '0'),
            expireJob: String(val?.expiredJobs ?? 0).padStart(2, '0')
        },
        {
            color: '#EA5D59',
            link: '/admin/candidate',
            title: 'Candidates',
            value: String((val?.activeCandidates ?? 0) + (val?.inactiveCandidates ?? 0)).padStart(2, '0'),
            icons: SiDialogflow,
            activeCandidates: String(val?.activeCandidates ?? 0).padStart(2, '0'),
            nonActiveCand: String(val?.inactiveCandidates ?? 0).padStart(2, '0')
        },
        {
            color: '#894910',
            link: '/admin/interview',
            title: 'Interviews',
            value: String(
                (val?.cancelledInterviews ?? 0) +
                (val?.scheduledInterviews ?? 0) +
                (val?.completedInterviews ?? 0)
            ).padStart(2, '0'),
            icons: TbBrandAirtable,
            scheduleInterview: String(val?.scheduledInterviews ?? 0).padStart(2, '0'),
            CancelledInterview: String(val?.cancelledInterviews ?? 0).padStart(2, '0'),
            completedInterview: String(val?.completedInterviews ?? 0).padStart(2, '0')
        },
        {
            color: '#eba52d',
            link: '/admin/purchase_order',
            title: 'Purchase Order',
            value: String(
                (val?.candidatePurchaseOrders ?? 0) +
                (val?.supplierPurchaseOrders ?? 0) +
                (val?.clientPurchaseOrders ?? 0)
            ).padStart(2, '0'),
            icons: BiPurchaseTagAlt,
            candidateOrder: String(val?.candidatePurchaseOrders ?? 0).padStart(2, '0'),
            supplierOrder: String(val?.supplierPurchaseOrders ?? 0).padStart(2, '0'),
            clientOrder: String(val?.clientPurchaseOrders ?? 0).padStart(2, '0')
        },
        { color: '#f5d133', link: '#', title: "Invoice Details", value: '-', icons: TbFileInvoice, pendingInvoice: '-', totalInvoice: '-', paidInvoice: '-', invoiceOverdue: '-' },
        { color: '#d9c14c', link: '#', title: "Payments", value: '-', icons: FaAmazonPay, pendingPayments: '-', totalPaymentsProcessed: '-', compltedPayments: "-" },
        { color: '#c8ed64', link: '#', title: "Revenue", value: '-', icons: FaCcAmazonPay, todayRevenue: '-', revenueThis_Month: "-", revenueGrowth: '-' }
    ];

    const [width, setWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };


        window.addEventListener('resize', handleResize);

        // Set initial width
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    //   console.log("Hello.........",width)

    const vendors = [
        { vendorId: '001', name: 'ABC Technologies', selectedCandidates: 15, revenue: 10500 },
        { vendorId: '002', name: 'XYZ Solutions', selectedCandidates: 8, revenue: 5200 },
        { vendorId: '003', name: 'Global Enterprises', selectedCandidates: 12, revenue: 8900 },
        { vendorId: '004', name: 'NextGen Services', selectedCandidates: 20, revenue: 12800 },
        { vendorId: '005', name: 'Innovate Corp', selectedCandidates: 5, revenue: 3100 },
        { vendorId: '006', name: 'Digital Works', selectedCandidates: 25, revenue: 16400 },
    ];

    const interviewDetails = [
        {
            candidateName: "John Doe",
            interviewerName: "Sarah Smith",
            interviewType: "In-Person",
            jobPosition: "Software Engineer",
            timeAndDate: "2024-11-10 10:00 AM",
            hiringResource: "Alex Johnson",
            supplierResource: "Kate Brown"
        },
        {
            candidateName: "Emma White",
            interviewerName: "Michael Lee",
            interviewType: "Virtual",
            jobPosition: "Data Scientist",
            timeAndDate: "2024-11-10 02:00 PM",
            hiringResource: "Laura Clark",
            supplierResource: "David Scott"
        },
        {
            candidateName: "Liam Black",
            interviewerName: "Rachel Green",
            interviewType: "In-Person",
            jobPosition: "Product Manager",
            timeAndDate: "2024-11-11 11:00 AM",
            hiringResource: "Tom Harris",
            supplierResource: "Nancy Cooper"
        },
        {
            candidateName: "Olivia Brown",
            interviewerName: "James Wilson",
            interviewType: "Virtual",
            jobPosition: "UX Designer",
            timeAndDate: "2024-11-12 09:00 AM",
            hiringResource: "Emily Roberts",
            supplierResource: "Samuel Evans"
        },
        {
            candidateName: "Ethan Gray",
            interviewerName: "Elizabeth Turner",
            interviewType: "In-Person",
            jobPosition: "Marketing Specialist",
            timeAndDate: "2024-11-12 03:00 PM",
            hiringResource: "Olivia Scott",
            supplierResource: "Robert White"
        },
        {
            candidateName: "Ava Wilson",
            interviewerName: "Andrew Clark",
            interviewType: "Virtual",
            jobPosition: "Data Engineer",
            timeAndDate: "2024-11-13 01:30 PM",
            hiringResource: "Mark Thompson",
            supplierResource: "Clara Hill"
        }
    ];

    //   minWidth:'20rem',
    // overflowX: 'auto',

    const styles = {
        container: {
            width: '94%',
            margin: '0 auto',
            padding: '20px',
            backgroundColor: 'white'
        },
        tableWrapper: {
            overflowX: 'auto',  // Enable horizontal scrolling on small screens
            marginTop: '20px',
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            marginTop: '20px',
        },
        thTd: {
            padding: '12px 15px',
            textAlign: 'left',
            border: '1px solid #ddd',
        },
        th: {
            padding: '13px',
            backgroundColor: '#4CAF50',
            color: 'white',
            textAlign: 'start',
        },
        td: {
            textAlign: 'center',
            fontSize: '16px',
        },
        trEven: {
            backgroundColor: '#f2f2f2',
        },
        trHover: {
            backgroundColor: '#ddd',
            cursor: 'pointer',
        },
    };


    return (
        <div
            style={{
                paddingTop: '1rem',
                backgroundColor: '#fcfcfc'
            }}
        >
            <div style={{
                color: '#286A94', fontWeight: '600', width: '95%',
                margin: '0 auto',
            }}>Welcome Admin</div>
            {loading ? <div style={{ height: "70vh", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Loader />
            </div> : <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(18rem, 1fr))',
                    columnGap: width > 800 ? '' : '10px',
                    rowGap: '55px',
                    marginBottom: 0,
                    width: '95%',
                    margin: '0 auto',
                    justifyItems: 'center'
                }}
            >
                    {head?.map((item, key) => (
                    <Head1
                        index={item.key}
                        color={item.color}
                        title={item.title}
                        value={item.value}
                        icons={item.icons}
                        width={width}
                        link={item.link}
                        details={{
                            activeVendor: item.activeVendor,
                            InactiveVendor: item.nonActiveVendor,
                            verifiedVendor: item.verifiedVendor,
                            nonVerifiedVendor: item.nonVerifiedVendor,
                            postedJobs: item.postedJob,
                            DraftedJobs: item.draftedJobs,
                            DeletedJobs: item.deletedJobs,
                            expiredJobs: item.expireJob,
                            selectedCandidates: item.selectedCandidate,
                            activeCandidates: item.activeCandidates,
                            InactiveCandidates: item.nonActiveCand,
                            scheduleInterviews: item.scheduleInterview,
                            CancelledInterviews: item.CancelledInterview,
                            completedInterviews: item.completedInterview,
                            candidateOrder: item.candidateOrder,
                            supplierOrder: item.supplierOrder,
                            clientOrder: item.clientOrder,
                            pendingInvoice: item.pendingInvoice,
                            totalInvoice: item.totalInvoice,
                            paidInvoice: item.paidInvoice,
                            invoiceOverdue: item.invoiceOverdue,
                            pendingPayments: item.pendingPayments,
                            totalPaymentsProcessed: item.totalPaymentsProcessed,
                            compltedPayments: item.compltedPayments,
                            todayRevenue: item.todayRevenue,
                            revenueThis_Month: item.revenueThis_Month,
                            revenueGrowth: item.revenueGrowth
                        }}
                    />
                ))}
            </div>}

            {/* <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', width: '97%', margin: '0 auto', marginTop: '2.4rem' }}>
                <div style={{
                    width: '45rem', height: '100%', margin: 20, backgroundColor: 'white', padding: 10,
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    padding: '10px',
                    backgroundColor: '#fff'
                }}>
                    <div style={{ padding: 15 }}> Total Order </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={data} margin={{ left: 0, bottom: 0 }} >
                            <XAxis dataKey="name" stroke="#8884d8" />
                            <YAxis />
                            <Tooltip wrapperStyle={{ width: 200, backgroundColor: '#ccc' }} />
                            <Legend width={100} wrapperStyle={{ width: 150, top: 0, right: 20, backgroundColor: '#f5f5f5', border: '1px solid #d5d5d5', borderRadius: 3, lineHeight: '0px' }} />
                            <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                            <Bar dataKey="revenue" fill="rgb(40, 106, 148)" barSize={20} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
                <div style={{
                    width: '25rem', height: '100%', margin: 20, backgroundColor: 'white', padding: 10,
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    padding: '10px',
                    backgroundColor: '#fff'
                }}>
                    <div style={{ padding: 15 }}> Overview </div>
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={pieData}
                                dataKey="value"
                                nameKey="name"
                                outerRadius="80%"
                                label
                            >
                                {pieData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div> */}

            {/* table code */}
            {/* <div style={styles.container}>
                <h2 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>Top Vendor Details</h2>

                <div style={styles.tableWrapper}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Vendor ID</th>
                                <th style={styles.th}>Vendor Company</th>
                                <th style={styles.th}>Selected Candidates</th>
                                <th style={styles.th}>Revenue</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendors.map((vendor, index) => (
                                <tr
                                    key={vendor.vendorId}
                                    style={index % 2 === 0 ? { ...styles.trEven, cursor: 'pointer' } : { cursor: 'pointer' }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles.trHover.backgroundColor)}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? styles.trEven.backgroundColor : '')}
                                >
                                    <td style={styles.thTd}>{vendor.vendorId}</td>
                                    <td style={styles.thTd}>{vendor.name}</td>
                                    <td style={styles.thTd}>{vendor.selectedCandidates}</td>
                                    <td style={styles.thTd}>${vendor.revenue.toLocaleString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div> */}
            {/* <div
                style={{
                    display: 'flex',
                    flexFlow: width > 768 ? 'row' : 'column',
                    gap: 10,
                    margin: '1rem 0',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    width: '94%',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    flexWrap: 'wrap'
                }}
            >
                <div
                    style={{
                        width: width > 768 ? '49%' : '90%',
                        margin: width > 768 ? '0' : '0px auto',
                        backgroundColor: '#ebd3b4',
                        padding: '0.7rem',
                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
                        borderRadius: '0.375rem',
                        height: width > 768 ? '12rem' : '100%'
                    }}
                >
                    <h3
                        style={{
                            fontSize: '1.125rem',
                            fontWeight: '600',
                            color: '#f8a63b'
                        }}
                    >
                        Interview Details
                    </h3>
                    <p
                        style={{
                            fontSize: '0.875rem',
                            padding: '0.75rem 0',
                            color: 'black',
                            fontWeight: '300'
                        }}
                    >
                        Visual comparisons between different time periods, regions, products, etc., often shown through side-by-side graphs or charts.
                    </p>
                    <div style={{ display: 'flex', flexDirection: 'row', gap: '1.25rem' }}>
                        <div>
                            <p style={{ fontSize: '0.875rem', fontWeight: '300' }}>
                                Search
                            </p>
                            <h1
                                style={{
                                    fontSize: '1.5rem',
                                    lineHeight: '2rem',
                                    fontWeight: '700',
                                    margin: '0.25rem 0',
                                    color: 'white'
                                }}
                            >
                                12.3k{' '}
                            </h1>
                        </div>
                        <div>
                            <p style={{ fontSize: '0.875rem', fontWeight: '300' }}>Apply</p>
                            <h1
                                style={{
                                    fontSize: '1.5rem',
                                    lineHeight: '2rem',
                                    fontWeight: '700',
                                    margin: '0.25rem 0',
                                    color: 'white'
                                }}
                            >
                                14k
                            </h1>
                        </div>
                        <div>
                            <p style={{ fontSize: '0.875rem', fontWeight: '300' }}>Users</p>
                            <h1
                                style={{
                                    fontSize: '1.5rem',
                                    lineHeight: '2rem',
                                    fontWeight: '700',
                                    margin: '0.25rem 0',
                                    color: 'white'
                                }}
                            >
                                71.56%
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    style={{
                        width: width > 768 ? '49%' : '90%',
                        margin: width > 768 ? '0' : '0px auto',
                        backgroundColor: '#286a94',
                        padding: '0.75rem',
                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
                        borderRadius: '0.375rem',
                        display: 'flex',
                        height: width > 768 ? '12rem' : '100%'
                    }}
                >
                    <div style={{ width: '50%', height: '100%', display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
                        <h2 style={{ fontSize: '1.125rem', height: '100%', fontWeight: '600', color: 'white' }}>
                            Vendor Meetings
                        </h2>
                        <h5 style={{ color: 'white', height: '100%' }}>34043</h5>
                        <div style={{ fontSize: '12px', color: 'white' }}>
                            Maps or geographical representations that show data points based on
                            locations, useful for analyzing regional performance or distribution.
                        </div>
                    </div>
                    <div style={{ width: '50%', height: '10rem' }}>
                        <img
                            style={{ width: '100%', height: '100%' }}
                            src="https://themewagon.github.io/skydash/images/dashboard/shape-4.svg"
                            alt="img"
                        />
                    </div>
                </div>
            </div> */}
            {/* <div style={{ ...styles.container, width: '96%' }}>
                <h2 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}> Recent Schedule Interview </h2>
                <div style={styles.tableWrapper}>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={styles.th}>Candidate Name</th>
                                <th style={styles.th}>Interviewer Name</th>
                                <th style={styles.th}> Interview Type </th>
                                <th style={styles.th}> Job Position </th>
                                <th style={styles.th}> Time & Date </th>
                                <th style={styles.th}> Hiring Resource </th>
                                <th style={styles.th}> supplier Resource </th>
                            </tr>
                        </thead>
                        <tbody>
                            {interviewDetails.map((vendor, index) => (
                                <tr
                                    key={index}
                                    style={index % 2 === 0 ? { ...styles.trEven, cursor: 'pointer' } : { cursor: 'pointer' }}
                                    onMouseOver={(e) => (e.currentTarget.style.backgroundColor = styles.trHover.backgroundColor)}
                                    onMouseOut={(e) => (e.currentTarget.style.backgroundColor = index % 2 === 0 ? styles.trEven.backgroundColor : '')}
                                >
                                    <td style={styles.thTd}>{vendor.candidateName}</td>
                                    <td style={styles.thTd}>{vendor.interviewerName}</td>
                                    <td style={styles.thTd}>{vendor.interviewType}</td>
                                    <td style={styles.thTd}>{vendor.jobPosition}</td>
                                    <td style={styles.thTd}>{vendor.timeAndDate}</td>
                                    <td style={styles.thTd}>{vendor.hiringResource}</td>
                                    <td style={styles.thTd}>{vendor.supplierResource}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div> */}
        </div>
    )
}

export default Content;

export const Head1 = ({ color, title, value, icons: Icon, width, details, link }) => {
    const navigate = useNavigate();
    const toReadableText = (str) => {
        return str.replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/_/g, ' ')                    
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };
    return (
        <div onClick={() => navigate(link)}
            style={{
                width: width > 500 ? '15.5rem' : '100%',
                height: '100%',
                borderRadius: '0.375rem',
                backgroundColor: 'white',
                cursor: "pointer",
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                marginTop: '2.5rem',
                position: 'relative'
            }}
        >
            <div
                style={{
                    width: '4rem',
                    borderRadius: '0.375rem',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '3.5rem',
                    left: '10%',
                    position: 'absolute',
                    top: '-2rem',
                    backgroundColor: color
                }}
            >
                <Icon style={{ fontSize: '1.25rem', color: 'white' }} />
            </div>
            <div>
                <div
                    style={{
                        width: '83.333%',
                        height: '100%',
                        margin: '0 auto',
                        display: 'flex',
                        flexWrap: 'wrap',
                        justifyContent: 'space-between',
                        alignItems: 'flex-end',
                    }}
                >
                    <div
                        style={{
                            fontFamily: 'Poppins',
                            color: '#6B240C',
                            fontWeight: '500',
                            paddingTop: '2rem'
                        }}
                    >
                        {title}
                    </div>
                    <div style={{ fontSize: '1.8rem', fontWeight: '500', color: '#6B240C' }}>
                        {value}
                    </div>
                </div>

                <div
                    style={{
                        marginTop: '1rem',
                        paddingLeft: '1rem',
                        paddingRight: '1rem'
                    }}
                >
                    {Object.keys(details).map((key) => (
                        details[key] || details[key] === 0 ? (
                            <div key={key} style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0.2rem',
                                fontSize: '14px'
                            }}>
                                <div>{toReadableText(key)}: </div>
                                <div>{details[key]}</div>
                            </div>
                        ) : null
                    ))}
                </div>
            </div>
        </div>
    );
};
